// EventSlider.jsx
import React, { useEffect, useRef, useState } from 'react';
import { RenderIf } from 'utilities/helpers';
import { Ikon } from 'assets/icons';
import { Column, Row } from 'layouts/container';
import styles from './preparedStockSlider.module.css';

const stocks = [
  {
    stock: 'Low Stock ☹️',
    isLowStock: true,
    demand: 'Demand 🔥',
    expiry: '',
    promotion: '',
    type: 'Item',
    servings: '05',
    title: 'Chicken Naaniza',
  },
  {
    stock: 'In-Stock 😊',
    isLowStock: false,
    demand: 'Demand 🔥',
    expiry: '',
    promotion: '',
    type: 'Item',
    servings: '05',
    title: 'Pita Bread',
  },
  {
    stock: '',
    isLowStock: false,
    demand: '',
    expiry: 'Near Expiry 😟',
    promotion: '50% off your order',
    type: 'Item',
    servings: '05',
    title: 'Smash Burger',
  },
  {
    stock: 'Low Stock ☹️',
    isLowStock: true,
    demand: 'Demand 🔥',
    expiry: '',
    promotion: '',
    type: 'Item',
    servings: '05',
    title: 'Chicken Naaniza',
  },
  {
    stock: '',
    isLowStock: false,
    demand: '',
    expiry: 'Near Expiry 😟',
    promotion: '50% off your order',
    type: 'Item',
    servings: '05',
    title: 'Pita Bread',
  },
];

const PreparedStockSlider = () => {
  const scrollRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const scrollRight = () => {
    scrollRef.current.scrollBy({
      left: 201,
      behavior: 'smooth',
    });
  };
  const scrollLeft = () => {
    scrollRef.current.scrollBy({
      left: -201,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        setIsScrolled(scrollRef.current.scrollLeft > 100);
      }
    };

    const refCurrent = scrollRef.current;
    if (refCurrent) {
      refCurrent.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div className={styles.sliderContainer}>
        <button className={styles.scrollButton} onClick={() => { scrollLeft(); }} disabled={!isScrolled}>
            <Ikon name={`event-slider-prev`} />
        </button>
        <div className={styles.sliderContent}>
            <div className={styles.cardList} ref={scrollRef}>
                {stocks.map((stock, index) => (
                  <div className={styles.eventCard} key={index}>
                    <Row gap={10} alignItems={'center'} justifyContent={'space-between'}>
                      <div className={styles.type}>{stock.type}</div>
                      <Column gap={4} alignItems={'flex-end'}>
                        <RenderIf isTrue={stock?.stock}>
                          <div className={stock?.isLowStock ? `${styles.badge} ${styles.badge_orange}` : `${styles.badge} ${styles.badge_green}`}>{stock?.stock}</div>
                        </RenderIf>
                        <RenderIf isTrue={stock?.expiry}>
                          <div className={`${styles.badge} ${styles.badge_red}`}>{stock?.expiry}</div>
                        </RenderIf>
                        <RenderIf isTrue={stock?.demand}>
                          <div className={`${styles.badge} ${styles.badge_gradient}`}>{stock?.demand}</div>
                        </RenderIf>
                        <RenderIf isTrue={stock?.promotion}>
                          <div className={`${styles.badge} ${styles.badge_promotion}`}>{stock?.promotion}</div>
                        </RenderIf>
                      </Column>
                    </Row>
                    <Row gap={10} alignItems={'center'} justifyContent={'space-between'}>
                      <div className={styles.title}>{stock?.title}</div>
                      <Row gap={6} alignItems={'center'} width={'auto'}>
                        <div className={styles.servings}>Servings</div>
                        <div className={styles.servings_badge}>{stock?.servings}</div>
                      </Row>
                    </Row>
                  </div>
                ))}
            </div>
        </div>
        <button className={styles.scrollButton} onClick={() => { scrollRight(); }}>
            <Ikon name={`event-slider-next`} />
        </button>
    </div>
  );
};

export default PreparedStockSlider;
